export default function handleFindPageData(data, slug) {
  return (data !== undefined && slug !== undefined)
    ? data.find((item) => item.slug === slug)
    : false;
}
